
import React from 'react'
import loadable from '@loadable/component'
import pMinDelay from 'p-min-delay'
import Loader from './shared/Loader'

// Layouts
import LayoutBlank from './shared/layouts/LayoutBlank'
import LayoutWithoutSidenav from './shared/layouts/LayoutWithoutSidenav'
import Layout2 from './shared/layouts/Layout2'

// Lazy load component
const lazy = (cb) => loadable(() => pMinDelay(cb(), 200), { fallback: <Loader /> })

// ---
// Default application layout

export const DefaultLayout = Layout2

// ---
// Document title template

export const titleTemplate = '%s - Gecko Visions'

// ---
// Routes
//
// Note: By default all routes use { "exact": true }. To change this
// behaviour, pass "exact" option explicitly to the route object

export const defaultRoute = '/'
export const routes = [
  {
    path: '/',
    layout: LayoutBlank,
    component: lazy(() => import('./pages/auth/Login'))
  },
  {
    path: '/logout',
    layout: LayoutBlank,
    component: lazy(() => import('./pages/auth/Logout'))
  },{
    path: '/auth/forgotpassword',
    layout: LayoutBlank,
    component: lazy(() => import('./pages/auth/ForgotPassword'))
  },{
    path: '/auth/resetpassword/:email',
    layout: LayoutBlank,
    component: lazy(() => import('./pages/auth/ResetPassword'))
  },
  {
    path: '/signup/plans',
    layout: LayoutWithoutSidenav,
    component: lazy(() => import('./pages/signup/Plans'))
  },
  {
    path: '/signup/register/:producId/:planId',
    layout: LayoutWithoutSidenav,
    component: lazy(() => import('./pages/signup/Register'))
  },
  {
    //path: '/signup/payment/:producId/:planId',
    path: '/signup/payment/',
    layout: LayoutWithoutSidenav,
    component: lazy(() => import('./pages/signup/Payment'))
  },
  {
    path: '/Receiver',
    protected: true,
    component: lazy(() => import('./pages/labs/Receiver'))
  },
  {
    path: '/Transmitter/:id',
    protected: true,
    component: lazy(() => import('./pages/labs/Transmitter'))
  },
  {
    path: '/Patients',
    protected: true,
    component: lazy(() => import('./pages/patients/Patients'))
  }, 
  {
    path: '/Patients/:id',
    protected: true,
    sidenavBack: true,
    component: lazy(() => import('./pages/patients/Patient'))
  },
  {
    path: '/Patient',
    protected: true,
    sidenavBack: true,
    component: lazy(() => import('./pages/patients/Patient'))
  },
  {
    path: '/ClinicHistorys',
    protected: true,
    component: lazy(() => import('./pages/patients/ClinicHistorys'))
  },
  {
    path: '/Patients/:idpatient/ClinicHistorys/:id',
    protected: true,
    sidenavBack: true,
    component: lazy(() => import('./pages/patients/ClinicHistory'))
  },
  {
    path: '/Patients/:idpatient/ClinicHistory',
    protected: true,
    sidenavBack: true,
    component: lazy(() => import('./pages/patients/ClinicHistory'))
  },
  {
    path: '/Patients/:idpatient/Tests',
    protected: true,
    component: lazy(() => import('./pages/patients/ClinicHistory'))
  },
  {
    path: '/Patients/:idpatient/Tests',
    protected: true,
    component: lazy(() => import('./pages/patients/Tests'))
  },
  {
    path: '/Patients/:idpatient/Tests/:id',
    protected: true,
    component: lazy(() => import('./pages/patients/Test'))
  },
  {
    path: '/Patients/:idpatient/Test',
    protected: true,
    sidenavBack: true,
    component: lazy(() => import('./pages/patients/Test'))
  },
  {
    path: '/Patients/:idpatient/TestResult/:id',
    protected: true,
    sidenavBack: true,
    component: lazy(() => import('./pages/patients/TestResult'))
  },
  {
    path: '/Configuration',
    protected: true,
    component: lazy(() => import('./pages/configuration/Configuration'))
  },
  {
    path: '/Room',
    protected: true,
    sidenavBack: true,
    component: lazy(() => import('./pages/configuration/Room'))
  },
  {
    path: '/Rooms/:id',
    protected: true,
    sidenavBack: true,
    component: lazy(() => import('./pages/configuration/Room'))
  },
  {
    path: '/Calendar',
    protected: true,
    component: lazy(() => import('./pages/calendar/Calendar'))
  }, 
]